import { CitySelect, CountrySelect, StateSelect } from '@/views/screens/common';
import { Col, Row } from 'antd';
import type { FC } from 'react';
import FormInput from '../../../../../components/Inputs/FormInput';
import FormTextArea from '../../../../../components/Inputs/FormTextArea';
import PostalCodeInput from '../../../../../components/Selectors/PostalCodeInput';

const ClaimsSettingsCompanyAddressForm: FC = () => {
  // TODO: possible bug, ClaimsSettingsCompanyAddressForm commented props
  return (
    <Row gutter={15}>
      <Col md={12}>
        <FormInput editMode label="Contact Person Name" margin="mb-10" />
        <FormInput editMode label="Title" margin="mb-10" />
        <FormInput editMode label="Contact Number" margin="mb-10" />
        <FormTextArea editMode label="Address" margin="mb-10" rows={3} />
      </Col>
      <Col md={12}>
        <CountrySelect label="Country" editMode margin="mb-10" />
        <PostalCodeInput
          editMode
          label="Postal Code"
          placeholder="Enter postal code"
          margin="mb-10"
          //   handleZipDetails={handleZipDetails}
          //   countryCode={countryCode}
        />
        <StateSelect
          editMode
          margin="mb-10"
          label="State"
          //   countryCode={countryCode}
        />
        <CitySelect
          editMode
          margin="mb-10"
          name="city"
          //   countryCode={countryCode}
          //   stateCode={stateCode}
        />
      </Col>
    </Row>
  );
};

export default ClaimsSettingsCompanyAddressForm;
